(() => {
  if (window.bonorumMotionLoaded) return;
  window.bonorumMotionLoaded = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false, frame = 0, observer, refreshFrame = 0, mutationObserver;
  const seen = new WeakSet(), observed = new Set(), active = new Set();
  let scenes = [];
  const enabled = () => !paused && !reduce.matches;
  const permitted = node => !node.closest('[data-bn-motion="false"]');
  const animate = (node, frames, duration = 1000, delay = 0) => {
    if (!enabled() || !permitted(node) || !node.animate) return;
    const a = node.animate(frames, {duration, delay, easing:'cubic-bezier(.16,1,.3,1)', fill:'backwards'});
    active.add(a);
    a.onfinish = a.oncancel = () => active.delete(a);
  };
  const selectView = (gallery, index) => {
    gallery.querySelectorAll('[data-bn-view]').forEach((view, i) => {
      view.classList.toggle('is-active', i === index);
      view.setAttribute('aria-hidden', String(i !== index));
    });
    gallery.querySelectorAll('[data-bn-view-button]').forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
  };
  const render = () => {
    frame = 0;
    if (!enabled()) return;
    const height = innerHeight;
    // v10: Erst alle Positionen lesen, dann alle Styles schreiben (verhindert Layout-Thrashing beim Scrollen).
    const boxes = scenes.map(({node}) => (node.isConnected && permitted(node)) ? node.getBoundingClientRect() : null);
    scenes.forEach(({node, type}, i) => {
      const box = boxes[i];
      if (!box) return;
      if (box.bottom < -100 || box.top > height + 100) return;
      if (type === 'cinema') {
        const travel = Math.max(1, box.height - height * .88);
        const progress = Math.max(0, Math.min(1, (height * .12 - box.top) / travel));
        node.style.setProperty('--bn-cinema-scale', (.84 + progress * .23).toFixed(4));
        node.style.setProperty('--bn-cinema-y', (32 - progress * 32).toFixed(2) + 'px');
        node.style.setProperty('--bn-cinema-progress', progress.toFixed(4));
        const gallery = node.querySelector('[data-bn-gallery]');
        if (gallery && !gallery.dataset.manual && innerWidth >= 1000 && innerHeight >= 700) {
          const count = gallery.querySelectorAll('[data-bn-view]').length;
          const index = Math.min(count - 1, Math.floor(progress * count));
          if (gallery.dataset.active !== String(index)) { selectView(gallery, index); gallery.dataset.active = String(index); }
        }
      } else if (type === 'story') {
        const hero = node.classList.contains('bn-story--hero');
        const progress = hero ? Math.max(0, Math.min(1, -box.top / box.height)) : Math.max(0, Math.min(1, (height - box.top) / (height + box.height)));
        node.style.setProperty('--bn-photo-scale', (hero ? 1.02 + progress * .07 : 1.09 - progress * .07).toFixed(4));
        node.style.setProperty('--bn-drift', (progress * 36).toFixed(2) + 'px');
        node.style.setProperty('--bn-copy-scale', (1 - progress * .055).toFixed(4));
      } else if (type === 'card') {
        const progress = Math.max(0, Math.min(1, (height - box.top) / (height * .7)));
        node.style.setProperty('--bn-card-scale', (.94 + progress * .06).toFixed(4));
      } else {
        const progress = Math.max(0, Math.min(1, (height - box.top) / (height * .7 + box.height * .5)));
        node.style.setProperty('--bn-scale', (.95 + .05 * progress).toFixed(4));
        node.style.setProperty('--bn-rise', ((1 - progress) * 24).toFixed(2) + 'px');
      }
    });
  };
  const schedule = () => { if (enabled() && !frame) frame = requestAnimationFrame(render); };
  const sync = () => {
    document.body.classList.toggle('bn-motion-paused', !enabled());
    document.querySelectorAll('[data-bn-toggle]').forEach(b => {
      b.hidden = reduce.matches;
      b.setAttribute('aria-pressed', String(paused));
      b.textContent = paused ? b.dataset.play : b.dataset.pause;
    });
    if (!enabled()) {
      active.forEach(a => a.cancel()); active.clear();
      scenes.forEach(({node}) => ['--bn-scale','--bn-rise','--bn-photo-scale','--bn-drift','--bn-copy-scale','--bn-card-scale','--bn-cinema-scale','--bn-cinema-y','--bn-cinema-progress'].forEach(x => node.style.removeProperty(x)));
    } else schedule();
  };
  const setup = () => {
    if (!observer && 'IntersectionObserver' in window) observer = new IntersectionObserver(entries => {
      entries.forEach(({target:node,isIntersecting}) => {
        if (!isIntersecting) return;
        observer.unobserve(node); observed.delete(node);
        if (seen.has(node)) return;
        seen.add(node);
        const staggered = node.matches('[data-bn-enter],.bn-world,.bn-trust__item,.bn-hl,.bn-store'); const unit = node.closest('li') || node; const delay = staggered && unit.parentElement ? Math.min([...unit.parentElement.children].indexOf(unit),6)*80 : 0;
        animate(node,[{opacity:0,transform:'translate3d(0,38px,0)'},{opacity:1,transform:'translate3d(0,0,0)'}],1100,delay);
      });
    },{threshold:.06});
    observed.forEach(n => {if(!n.isConnected){observer.unobserve(n);observed.delete(n);}});
    document.querySelectorAll('[data-bn-enter],.bn-feature__copy,.bn-category,.bn-section-heading,.bn-tabs__head,.bn-trust__item,.bn-world,.bn-hl,.bn-cfeature__banner,.bn-numbers__head,.bn-promo,.bn-store,.bn-compare__head,.template-product .detail .title-row,.template-product .detail .price-container,.template-collection .page-header h1').forEach(n=>{
      if(observer && !seen.has(n) && !observed.has(n)){observer.observe(n);observed.add(n);}
    });
    scenes = [...document.querySelectorAll('.bn-story')].map(node=>({node,type:'story'})).concat([...document.querySelectorAll('.bn-feature:not(.bn-cinema) .bn-feature__media,[data-bn-scale]')].map(node=>({node,type:'scale'}))).concat([...document.querySelectorAll('main .product-block:not(.product-block--compact),#content .product-block:not(.product-block--compact),.mock-products .product-block')].map(node=>({node,type:'card'}))).concat([...document.querySelectorAll('.bn-cinema')].map(node=>({node,type:'cinema'})));
    document.querySelectorAll('.bn-cinema').forEach(n=>n.classList.add('bn-cinema-ready'));
    document.querySelectorAll('[data-bn-gallery]').forEach(gallery => {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = 'true';
      gallery.querySelector('[data-bn-gallery-controls]').hidden = false;
      gallery.querySelectorAll('[data-bn-view-button]').forEach(button => button.addEventListener('click', () => {
        gallery.dataset.manual = 'true'; selectView(gallery, Number(button.dataset.bnViewButton));
      }));
    });
    document.querySelectorAll('.bn-story--hero .bn-story__image,.template-product .media-gallery__inner').forEach(n=>{
      if(seen.has(n))return;seen.add(n);
      // v10: Nur sanfter Zoom, keine Transparenz – das Hero-Bild ist sofort voll sichtbar (besser für Ladezeit-Wertung/LCP).
      animate(n,[{transform:'scale(1.06)'},{transform:'scale(1)'}],1600);
    });
    // v16: Kein extra Pause-Knopf auf Produkt- und Kategorieseiten (nur kurze Einblend-Effekte); reduzierte Bewegung folgt der Systemeinstellung.
    document.querySelectorAll('[data-bn-toggle]').forEach(b=>{if(b.dataset.bound)return;b.dataset.bound='true';b.addEventListener('click',()=>{paused=!paused;sync();});});
    document.querySelectorAll('[data-bn-return]').forEach(a=>{
      const main=document.querySelector('.product-info')?.closest('.shopify-section');
      if(main?.id)a.href='#'+main.id;
    });
    if (!mutationObserver && 'MutationObserver' in window) {
      const root = document.querySelector('main,#content');
      if (root) {
        mutationObserver = new MutationObserver(records => {
          const changed = records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches('.product-block,filter-container') || n.querySelector('.product-block'))));
          if (changed && !refreshFrame) refreshFrame = requestAnimationFrame(() => { refreshFrame = 0; setup(); });
        });
        mutationObserver.observe(root,{childList:true,subtree:true});
      }
    }
    sync();
  };
  addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});
  reduce.addEventListener('change',sync);
  document.addEventListener('shopify:section:load',setup);document.addEventListener('shopify:section:unload',setup);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
})();
